import { Box, Container, FormGroup, Paper, styled } from "@mui/material";

export const ContainerCustom4 = styled(Container)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

export const FormGroupCustom = styled(FormGroup)(({theme}) => ({
  marginBottom: theme.spacing(2),
  color: theme.palette.primary.main, 
})) 

export const PaperTooltipCustom = styled(Paper)(({ theme, tooltip }) => ({
  padding: theme.spacing(0),
  display: tooltip.show ? "block" : "none",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  pointerEvents: "none",
  position: "absolute",
  top: tooltip.top || 0,
  left: tooltip.left || 0,
  transition: "all .3s ease 0s",
  zIndex: 9999,
}));

export const PaperChartCustom = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1)
}));

export const BoxFilterBarCustom = styled(Box)(({theme}) => ({
  display: "none", 
  [theme.breakpoints.up("sm")] : {display: "flex"},
}))

export const BoxFilterBarCustomInvert = styled(Box)(({theme}) => ({
  display: "flex", 
  [theme.breakpoints.up("sm")] : {display: "none"},
}))

export const BoxSquareColor = styled(Box)(({theme, color, size}) => ({
  display: "inline-block",
  width: size ? size : 16,
  height: size ? size : 16,
  marginRight: theme.spacing(1),
  verticalAlign: "middle",
  backgroundColor: color,
}))

export const BoxModalCustom = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.background.default,
  boxShadow: 24,
  padding: theme.spacing(1),
  overflow: 'auto',
  // GESTIONE RESPONSIVE DELLE LARGHEZZE
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: '30%',
  },
}));



